import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { generateKey } from '../../../../insfrastructure/utils/array-key'
import { jobApplies } from '../../../../insfrastructure/services/job-applies'
import { Job, listJobs } from '../../../../insfrastructure/services/jobs'
import { ListResponse } from '../../../../insfrastructure/services/utils'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { TokenParams } from '../../../../insfrastructure/services/auth'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import { getAuthToken } from '../../../../insfrastructure/services/token-manager'
import searchIcon from '../../../../assets/icons/search.png'
import filterIcon from '../../../../assets/icons/filter.png'
import storageIcon from '../../../../assets/icons/storage.png'
import openedEyeIcon from '../../../../assets/icons/opened_eye.svg'
import Table from '../../../components/table'
import './styles.sass'


const JobSubscriptions = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [offerSubcriptions, setOfferSubcriptions] = useState<ListResponse<Job>>({
    results: [],
    count: 0
  })
  const [offset, setOffset] = useState(0)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState<string>('')
  const [jobApplyStatus, setJobApplyStatus] = useState<Record<string, any>>({})
  const [parsedJWT, setParsedJWT] = useState<TokenParams>()

  useEffect(() => {
    onParseJWT();
  }, [])
  

  useEffect(() => {
    if (!parsedJWT) {
      return;
    };

    listOffers({ 
      offset: searchParams.get('page') ? (parseInt(searchParams.get('page')+'') - 1) * 10 : 0,
      search: searchParams.get('search') || ''
    });
    getStaticValues();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parsedJWT, searchParams])

  const onParseJWT = async () => {
    try {
      const authToken = getAuthToken();
      if (!authToken) return;
      
      const parsedJWT: TokenParams = parseJwt(authToken);
      
      setParsedJWT(parsedJWT);
    } catch (error) {}
  }

  const listOffers = async ({offset, search}: Record<string, any>) => {
    try {
      setLoading(true);
      setOfferSubcriptions({
        results: [],
        count: 0
      });

      let params: any = { offset, limit: 10 };
      let urlParams: any = {page: (offset / 10) + 1 + ''};

      if (search) {
        params.search = search;
        urlParams.search = search;
      };

      let offers = await jobApplies(params);

      offers.results = await Promise.all((offers.results).map(async x => {
        try {
          const jobResponse = await listJobs({ id: x.jobpost_id });
          const job = jobResponse.data[0];
          x.job = job;
        } catch (error) {
          x.job = null;
        }

        return x;
      }));

      offers.results = offers.results.filter(x => !!x.job);

      setOfferSubcriptions(offers);
      setOffset(offset);
      setSearch(search || '');
      setSearchParams(urlParams);
      
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }

  const getJobTitle = (offer_subcription: any) => {
    // Tentar diferentes campos para o nome da vaga
    const jobTitle = offer_subcription?.job?.jobTitle?.name ||
                    offer_subcription?.job?.job_title ||
                    offer_subcription?.job?.title ||
                    offer_subcription?.job?.name ||
                    offer_subcription?.job_title ||
                    offer_subcription?.title ||
                    offer_subcription?.name ||
                    'Vaga sem título';
    
    return jobTitle;
  }

  const getCandidacyDate = (offer_subcription: any) => {
    if (!offer_subcription || !offer_subcription.status) return '-';
    
    const status = offer_subcription.status;
    let date;
    let label;
    
    switch (status) {
      case 'applied':
        date = offer_subcription?.created_at;
        label = 'Se candidatou:';
        break;
      case 'interview':
        date = offer_subcription?.interview_date;
        label = 'Entrevista:';
        break;
      case 'hired':
        date = offer_subcription?.hired_date;
        label = 'Aprovação:';
        break;
      case 'rejected':
      case 'not_fit':
        date = offer_subcription?.status_updated_at;
        label = 'Reprovado:';
        break;
      case 'fulfilled':
        date = offer_subcription?.status_updated_at;
        label = 'Vaga preenchida:';
        break;
      case 'cancelled':
        date = offer_subcription?.status_updated_at;
        label = 'Vaga cancelada:';
        break;
      default:
        date = offer_subcription?.created_at;
        label = 'Candidatura:';
    }
    
    if (!date) {
      return `${label} -`;
    }
    
    if (!moment(date).isValid()) {
      return `${label} -`;
    }
    
    // Para entrevistas, mostrar data e horário
    if (status === 'interview') {
      return `${label} ${moment(date).format('DD/MM/yyyy HH:mm')}`;
    }
    
    return `${label} ${moment(date).format('DD/MM/yyyy')}`;
  }

  const getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        const jobapply_status = staticValues.jobapply_status;

        setJobApplyStatus(jobapply_status);
      }, 1000);
    } catch (error) {}
  }

  const onSearch = async () => {
    listOffers({ offset: 0, search: search || '' });
  }

  return (
      <div className='job-subscriptions company-page'>
        <div className='block'>
            <div className='block-header'>
              <div className='title'>
                <img src={storageIcon} alt='icon' />
                <h3>Minhas candidaturas</h3>
              </div>
            </div>
            <div className='oportunities-searcher'>
              <img className='search-icon' src={searchIcon} alt='search' onClick={onSearch} />
              <input type='text' placeholder='Pesquisar vaga' value={search || ''} onChange={e => setSearch(e.target.value)} />
              <img className='filter-icon' src={filterIcon} alt='filter' />
            </div>
            <div className='offers'>
                <div className='job-results'>
                  <Table
                  data={offerSubcriptions.results}
                  total={offerSubcriptions.count}
                  limit={10}
                  offset={offset}
                  loading={loading}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  onNavigate={(params: any) => {
                    listOffers({ offset: params.offset, search: search || '' });
                  }}
                  header={
                    <thead>
                      <tr>
                        <th className='name'>Nome da vaga:</th>
                        <th>Última atualização:</th>
                        <th>Status:</th>
                      </tr>
                    </thead>
                  }
                  body={
                    (offer_subcriptions: any) => {
                      return offer_subcriptions.map((offer_subcription: any, index: number) =>
                        <tr key={generateKey('offer_'+index)}>
                          <td>{getJobTitle(offer_subcription)}</td>
                          <td>{getCandidacyDate(offer_subcription)}</td>
                          <td>
                            <span className={
                              'status '+offer_subcription.status
                            }>{ jobApplyStatus[offer_subcription.status] }</span>
                          </td>
                          <td>
                            <Link to={'/offers/'+offer_subcription.jobpost_id+'/details'}>
                              <img className='edit-icon' alt='see' src={openedEyeIcon} />
                            </Link>
                          </td>
                        </tr>)
                    }
                  }/>
                </div>
            </div>
        </div>
      </div>
  )
}

export default JobSubscriptions;
